<template>
  <VTooltip
    v-bind="$props"
    v-model="showToolTip"
    max-width="200px"
    close-delay="0"
    open-delay="0"
    transition="scale-transition"
    :color="color"
    style="opacity:1.0 !important;color:black !important;background-color:white !important"
    :bottom="bottom"
  >
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <slot />
      </span>
    </template>
    <div
      style="color:black !important;"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
    >
      {{ text }}
    </div>
  </VTooltip>
</template>

<script>
export default {
    name: "PsImageTooltip",
    props: {
        bottom: {
            type: Boolean,
            required: false,
            default: true
        },
        color: {
            type: String,
            required: false,
            default: "#ffffff"
        },
        text: {
            type: String,
            required: false,
            default: ""
        }
    },
    data () {
        return {
            showToolTip: false,
            popupHover: false
        };
    },
    mounted () {
      window.Bus.$off("tooltipClose");
      window.Bus.$off("mousedOut");
      window.Bus.$on("mousedout", d => {      
        this.checkToolTipMouseOut(d);
      });
      window.Bus.$on("tooltipClose", d => {
        this.showToolTip = false;
        this.popupHover = false;
      });
    },
    methods: {
        checkToolTipMouseOut (e) {
          var toElement = $(e.toElement);        
          if(!toElement[0].className.startsWith("icon-")) {
                this.showToolTip = this.popupHover;
          }
        },
        mouseOver () {
            this.popupHover = true;
            this.showToolTip = true;
        },
        mouseLeave (e) {
            this.showToolTip = false;
            this.popupHover = false;
        }
    }
};
</script>
<style>
.p4-report .psTooltip {
  background-color: #467fa5 !important;
  color: white;
  border-radius: 50%;
  font-weight: bold;
  padding: 0px 4px;
  font-style: italic;
  font-family: serif;
  font-size: 0.8em;
}
</style>
